import { Badge, IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import VisibilityIcon from "@mui/icons-material/Visibility";

const UnhideButton = ({ label = "Show Hidden", onClick = () => {}, hiddenCount = 0 }) => {
  const { t } = useTranslation();
  return (
    <Tooltip title={`${t(label)} (${hiddenCount})`}>
      <span>
        <IconButton onClick={onClick} disabled={hiddenCount === 0} variant="Light Green">
          <Badge badgeContent={hiddenCount} color="primary">
            <VisibilityIcon />
          </Badge>
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default UnhideButton;
